import type { UserAccount } from '@ocode/domain';
import { create } from 'zustand';
import { LoginUser } from '../auth/LoginUser';

const DEBUG = false;

const ANONYMOUS = new LoginUser(undefined);

export interface AuthState {
  user: LoginUser;
  setUserProfile: (profile?: UserAccount) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: ANONYMOUS,
  setUserProfile: (profile?: UserAccount) => {
    console.log('useAuthStore.setUserProfile() profile=', profile);
    set((prev) => ({
      user: new LoginUser(profile),
    }));
  },
  logout: () => {
    if (DEBUG) {
      console.log('useAuthStore.logout()');
    }
    set((prev) => ({
      user: new LoginUser(undefined),
    }));
  },
}));

export const useLoginUser = (): LoginUser => useAuthStore((state) => state.user);
